import React from 'react';

const CHANNEL_URL = 'https://www.youtube.com/@TheChinaNotSeen';

const post = {
  slug: 'the-china-you-havent-seen',
  title: "The China You Haven't Seen: reporting on tech from the inside",
  date: '2026-09-16',
  cover: 'https://i.ytimg.com/vi/J_josp8egYg/maxresdefault.jpg',
  coverAlt: 'A large Chinese TV showing a fireplace in a dark living room',
  excerpt:
    "Introducing The China You Haven't Seen, our new YouTube channel. Next year we move to China, and we will be reporting on the country's technology trends from the inside.",
  content: (
    <>
      {/* TODO: channel art or logo — drop the file in public/blog/the-china-you-havent-seen/
          <img src="/blog/the-china-you-havent-seen/banner.png" alt="The China You Haven't Seen channel art" /> */}
      <p>
        We have started a new YouTube channel:{' '}
        <a href={CHANNEL_URL}>The China You Haven&apos;t Seen</a>. The short
        version: next year we are moving to China, and when we get there we
        will be reporting on the country&apos;s technology trends from the
        inside. The channel is live now, and the first videos are already up.
      </p>

      <h2>Why this channel</h2>
      <p>
        Most Western coverage of Chinese technology is either geopolitics or
        headline numbers. What rarely travels is the lived reality: the
        super-apps everything runs on, the delivery drones that are already
        routine, the consumer hardware that competes directly with the brands
        the rest of us know. We want to show that side of it, tested and
        filmed rather than summarised.
      </p>
      <p>
        The first three videos set the tone.{' '}
        <a href="https://www.youtube.com/watch?v=tL_Z6qEBd-0">
          Is iPhone Duo Already Behind China&apos;s Foldables?
        </a>{' '}
        puts Apple&apos;s phone up against Chinese folding hardware.{' '}
        <a href="https://www.youtube.com/watch?v=J_josp8egYg">
          We Tested 3 Luxury Chinese TVs Against Samsung &amp; Sony
        </a>{' '}
        is exactly what it says. And{' '}
        <a href="https://youtu.be/5eKPD3lkjuw">
          China&apos;s Delivery Drones Are Real, But Not How You Think
        </a>{' '}
        looks at drone delivery as it actually works, not as it gets
        described.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/tL_Z6qEBd-0"
          title="Is iPhone Duo Already Behind China's Foldables?"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>What to expect</h2>
      <p>
        A mixture of on-camera reporting and narrated pieces, covering
        consumer tech first and widening from there: foldables and phones,
        TVs and home hardware, drones, EVs, AI, and the apps and services
        that everyday life in China runs on. Some of it will be hands-on
        testing, some of it will be explaining what a technology looks like
        when it is simply part of the furniture.
      </p>

      <div className="video-embed">
        <iframe
          src="https://www.youtube.com/embed/5eKPD3lkjuw"
          title="China's Delivery Drones Are Real, But Not How You Think"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <h2>Get in early</h2>
      <p>
        The channel is starting before we move so that it exists, has a name,
        and has something on it by the time we land. If the idea appeals,{' '}
        <a href={CHANNEL_URL}>subscribe to The China You Haven&apos;t Seen</a>{' '}
        and follow it from day zero. The interesting part is still to come.
      </p>
    </>
  ),
};

export default post;
